import React from 'react';
import styled from 'styled-components';

import { paginationSpacer, paginationItem } from '../styles';

import { LEFT, RIGHT, leftType, rightType } from '../constants';

const StyledSpacer = styled.span`
  ${paginationItem}
  ${paginationSpacer}
`;

export interface SpacerConfig {
  currentPage: number;
  totalPages: number;
  pageRange: number;
}

export interface PaginationSpacerProps {
  currentPage: number;
  totalPages: number;
  pageRange: number;
  type?: leftType | rightType;
}
export function renderSpacer() {
  return <StyledSpacer>...</StyledSpacer>;
}

export function shouldDisplaySpacer(totalPages: number, pageRange: number): boolean {
  return totalPages > pageRange;
}

export function renderLeftSpacer({ totalPages, currentPage, pageRange }: SpacerConfig) {
  if (shouldDisplaySpacer(totalPages, pageRange)) {
    // example(s):
    // 1 ... [4] 5 6 7
    if (currentPage - 2 > 1) {
      return renderSpacer();
    }
    return null;
  }
  return null;
}

export function renderRightSpacer({ totalPages, currentPage, pageRange }: SpacerConfig) {
  if (shouldDisplaySpacer(totalPages, pageRange)) {
    // example(s):
    // 1 2 [3] 4 ... 7
    if (currentPage + 2 < totalPages) {
      return renderSpacer();
    }
    return null;
  }
  return null;
}

function PaginationSpacer({ type, ...otherProps }: PaginationSpacerProps) {
  switch (type) {
    case LEFT:
      return renderLeftSpacer(otherProps);
    case RIGHT:
      return renderRightSpacer(otherProps);
    default:
      return null;
  }
}

export default PaginationSpacer;
